export const FONTSIZE_KEY = 'fontSize'
